import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "navStep", "prevBtn", "nextBtn"]
  static values = { totalSteps: Number }

  connect() {
    this.currentStep = 1
    this.totalStepsValue = this.totalStepsValue || 5
    this.updateNavigation()
    this.bindNavigationEvents()
    this.bindTreeNodeEvents()
  }

  updateNavigation() {
    // Update navigation states
    this.navStepTargets.forEach((step, index) => {
      const stepNumber = index + 1
      step.classList.remove('bg-base-100', 'border-primary', 'text-primary', 'bg-success/10', 'border-success', 'text-success')
      
      if (stepNumber === this.currentStep) {
        step.classList.add('bg-base-100', 'border-primary', 'text-primary')
      } else if (stepNumber < this.currentStep) {
        step.classList.add('bg-success/10', 'border-success', 'text-success')
      }
    })

    // Update content visibility
    this.stepTargets.forEach((content, index) => {
      content.classList.remove('active')
      if (index + 1 === this.currentStep) {
        content.classList.add('active')
      }
    })

    // Update button states
    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.style.display = this.currentStep === 1 ? 'none' : 'inline-flex'
    }
    if (this.hasNextBtnTarget) {
      // this.nextBtnTarget.textContent = this.currentStep === this.totalStepsValue ? 'Start Collecting Data' : 'Next Step'
      this.nextBtnTarget.style.display = this.currentStep === this.totalStepsValue ? 'none' : 'inline-flex'
    }
  }

  nextStep() {
    if (this.currentStep < this.totalStepsValue) {
      this.currentStep++
      this.updateNavigation()
    } else {
      // Final step action
      alert('🎉 Your classification system is ready! Field teams can now start collecting data using your custom schema.')
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--
      this.updateNavigation()
    }
  }

  navigateToStep(event) {
    const stepElement = event.currentTarget
    const stepData = stepElement.dataset.step
    if (stepData) {
      this.currentStep = parseInt(stepData)
      this.updateNavigation()
    }
  }

  selectTreeNode(event) {
    const node = event.currentTarget
    // Remove selected class from all tree nodes
    this.element.querySelectorAll('.tree-node').forEach(n => n.classList.remove('selected'))
    // Add selected class to clicked node
    node.classList.add('selected')
  }

  bindNavigationEvents() {
    // Navigation click handlers
    this.navStepTargets.forEach((step) => {
      step.addEventListener('click', this.navigateToStep.bind(this))
    })
  }

  bindTreeNodeEvents() {
    // Interactive tree nodes
    this.element.querySelectorAll('.tree-node').forEach(node => {
      node.addEventListener('click', this.selectTreeNode.bind(this))
    })
  }
}
